<div class="patient-activity-modal">
  <div class="modal-header">
    <div class="patient-activity-modal__identity">
      <div class="patient-activity-modal__avatar" [style.background]="avatarColor">
        {{ initials }}
      </div>
      <div>
        <h5 class="modal-title">{{ patientName || 'Unknown Patient' }}</h5>
        <span class="patient-activity-modal__mrn" *ngIf="mrn">MRN {{ mrn }}</span>
      </div>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true"><i class="fas fa-times"></i></span>
    </button>
  </div>
  <div class="modal-body patient-activity-modal__body">
    <app-activity-timeline
      [events]="events"
      [loading]="loading"
      emptyMessage="No activity recorded yet for this patient."
    ></app-activity-timeline>
  </div>
</div>
